import React, { Fragment } from 'react'
import Header from '../components/layouts/Header'
import Footer from '../components/layouts/Footer'
import WhyUs from '../features/about_us/WhyUs'
import EngineerSection from '../features/about_us/EngineerSection'
import GetPerfectSection from '../features/about_us/GetPerfectSection'
import TimeSection from '../features/about_us/TimeSection'
import SpeedSection from '../features/about_us/SpeedSection'
import SimplifySection from '../features/about_us/SimplifySection'
import useDocumentTitle from '../hooks/useDocumentTitle';
const AboutUsPage = () => {
    useDocumentTitle("About Us");
    return (
        <Fragment>
            <Header />
            <main className="text-white">
                <WhyUs />
                <EngineerSection />
                <GetPerfectSection />
                <TimeSection />
                <SpeedSection />
                <SimplifySection />
            </main>
            <Footer />
        </Fragment>
    )
}

export default AboutUsPage